import { render, staticRenderFns } from "./PhoneDetailsV2.vue?vue&type=template&id=139d54d4&"
import script from "./PhoneDetailsV2.vue?vue&type=script&lang=js&"
export * from "./PhoneDetailsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports